export default __webpack_public_path__ + "static/media/add.c58abea6.svg";